import { N as NUMERIC_SEPARATOR } from './currency-49e0d692.js';

var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
const removeAllCommas = (input) => input.replace(/,/g, '');
/**
 * Returns a numeric price and replaces all COMMA with DOT
 * eg '125,876,454.5' => 12665876454.5
 *    '12121,151' => 12121.151
 */
const priceToFloat = (price) => {
    const regExp = /^[0-9]+(,+[0-9]+)+(\\.[0-9]+)$/;
    const newPrice = price.toString();
    return regExp.test(newPrice)
        ? parseFloat(removeAllCommas(newPrice))
        : parseFloat(newPrice.replace(NUMERIC_SEPARATOR.COMMA, NUMERIC_SEPARATOR.DOT));
};
const convertProductsPriceToFloat = (products) => {
    return products.map((product) => {
        const { price } = product, rest = __rest(product, ["price"]);
        if (!price) {
            return product;
        }
        return Object.assign({ price: priceToFloat(price) }, rest);
    });
};
const removeAllDots = (input) => input.replace(/\./g, '');
const extractThreeConsecutiveDigits = (input) => /^[0-9]{3}\b/.exec(input);
const handleBothCommaAndDot = ({ firstMatch, firstCommaIndex, firstDotIndex, lastCommaIndex, lastDotIndex, }) => {
    if (firstCommaIndex < firstDotIndex) {
        if (lastCommaIndex > lastDotIndex || lastDotIndex > firstDotIndex) {
            return NaN;
        }
        return Number(removeAllCommas(firstMatch));
    }
    if (lastCommaIndex < lastDotIndex || lastCommaIndex > firstCommaIndex) {
        return NaN;
    }
    return Number(removeAllDots(firstMatch).replace(NUMERIC_SEPARATOR.COMMA, NUMERIC_SEPARATOR.DOT));
};
const handleOnlyDot = (firstMatch, firstDotIndex, lastDotIndex) => {
    const threeDigits = extractThreeConsecutiveDigits(firstMatch.substring(firstDotIndex + 1));
    if (lastDotIndex > firstDotIndex || threeDigits) {
        return Number(removeAllDots(firstMatch));
    }
    return Number(firstMatch);
};
const handleOnlyComma = (firstMatch, firstCommaIndex, lastCommaIndex) => {
    const threeDigits = extractThreeConsecutiveDigits(firstMatch.substring(firstCommaIndex + 1));
    return Number((lastCommaIndex > firstCommaIndex || threeDigits)
        ? removeAllCommas(firstMatch)
        : firstMatch.replace(NUMERIC_SEPARATOR.COMMA, NUMERIC_SEPARATOR.DOT));
};
/**
 * The `parseFloatI18n` function is used to parse and convert a localized number string into a valid
 * JavaScript number. It handles different number string formats that may include commas or dots as decimal
 * separators, and it ensures that the number is correctly formatted for parsing.
 */
const parseFloatI18n = (input) => {
    const ZERO_INDEX = 0;
    if (typeof input !== 'string' || input === '') {
        return typeof input === 'number' ? input : NaN;
    }
    const numericMatches = /^[0-9.,eE-\s]+$/.exec(input);
    if (!numericMatches) {
        return parseFloat(input);
    }
    const [numericMatch] = numericMatches;
    const firstMatch = numericMatch.replace(/\s+/g, '');
    const firstCommaIndex = firstMatch.indexOf(NUMERIC_SEPARATOR.COMMA);
    const firstDotIndex = firstMatch.indexOf(NUMERIC_SEPARATOR.DOT);
    const lastCommaIndex = firstMatch.lastIndexOf(NUMERIC_SEPARATOR.COMMA);
    const lastDotIndex = firstMatch.lastIndexOf(NUMERIC_SEPARATOR.DOT);
    if (firstCommaIndex > ZERO_INDEX && firstDotIndex > ZERO_INDEX) {
        return handleBothCommaAndDot({
            firstMatch,
            firstCommaIndex,
            firstDotIndex,
            lastCommaIndex,
            lastDotIndex,
        });
    }
    if (firstDotIndex > ZERO_INDEX && firstCommaIndex < ZERO_INDEX) {
        return handleOnlyDot(firstMatch, firstDotIndex, lastDotIndex);
    }
    if (firstCommaIndex > ZERO_INDEX && firstDotIndex < ZERO_INDEX) {
        return handleOnlyComma(firstMatch, firstCommaIndex, lastCommaIndex);
    }
    if (firstCommaIndex === ZERO_INDEX || firstDotIndex === ZERO_INDEX) {
        return NaN;
    }
    return Number(firstMatch);
};

export { removeAllDots as a, handleOnlyDot as b, convertProductsPriceToFloat as c, handleOnlyComma as d, extractThreeConsecutiveDigits as e, parseFloatI18n as f, handleBothCommaAndDot as h, priceToFloat as p, removeAllCommas as r };
